import Resource from '../Resource'

class FragmentOrientationService extends Resource {
    async findAll(laboratoryId, portionTypeId) {
        const params = { portionTypeId: portionTypeId }
        const response = await this.axios.get(`common/laboratories/${laboratoryId}/fragmentorientations/`, { params })
        return response.data
    }
}

export default new FragmentOrientationService()
